/**
 * Pazien Collection - contains features from all Pazien data collections
 *
 * Includes features of parameterized collection with transform modifiers, stateful queries, and actionable features
 * @attention Use this Class only when necessary. Using this collection when not necessary will impact memory usage!
 */
import { ActionableCollection } from "./actionableCollection";
import { StatefulCollection } from "./statefulCollection";
import { ParameterizedTransformCollection } from "./parameterizedTransformCollection";

// We should still apply Stateful collection prototype.
// ActionableCollection does contain it, but it's set there in a constructor
export const PazienCollection = ParameterizedTransformCollection.extend({
    ...StatefulCollection.prototype,
    ...ActionableCollection.prototype
});
